import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class appConfigService {
    
    private appConfig : {
        uploadDocumentType: any[]
    };
    
    constructor(
        private http: HttpClient,
        private toastr: ToastrService,
        private authService: AuthService) 
    {
        this.appConfig = { uploadDocumentType: [] };
        this.getConfig();
    }

    get uploadDocType() { return this.appConfig.uploadDocumentType}
    
    public getConfig() {
        // El endpoint requiere token: sin sesión la llamada solo devuelve 401.
        if (!this.authService.isAuthenticated()) return;

        this.http.get(`${environment.apiUrl}/api/appconfig`)
        .subscribe((result:any) => {
            this.appConfig = result;
        }, err => { this.toastr.error(err); });
    }
}
